<template>
	<div :class="classes">
		<slot></slot>
	</div>
</template>

<script>
	export default {
	  name: 'Pane',
	  data() {
	    const classes = ['Pane', this.$parent.split, 'className'];
	    return {
	      classes: classes.join(' '),
	      percent: 50
	    }
	  }
	}
</script>



// WEBPACK FOOTER //
// src/common/components/extend/split-panel/pane.vue